import {ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Dropdown from 'flarum/common/components/Dropdown';
import Link from 'flarum/common/components/Link';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import listItems from 'flarum/common/helpers/listItems';
import Picture from '../models/Picture';
import {cimaiseAlbum, cimaisePicture} from '../routes';
import PictureControls from '../utils/PictureControls';

const translationPrefix = 'kilowhat-cimaise.forum.picture-thumbnail.';

interface PictureThumbnailAttrs {
    picture: Picture
    showUser: boolean
    showAlbum: boolean
    ondelete?: () => void
    openInLightbox?: boolean
}

export default class PictureThumbnail implements ClassComponent<PictureThumbnailAttrs> {
    view(vnode: Vnode<PictureThumbnailAttrs>) {
        const {picture} = vnode.attrs;

        const controls = PictureControls.controls(picture, {
            ondelete: vnode.attrs.ondelete,
        }).toArray();

        const href = cimaisePicture(picture);

        const onclick = (event: Event) => {
            if (vnode.attrs.openInLightbox) {
                event.preventDefault();
                app.cimaiseLightbox.open(picture);
            }
        };

        const active = m.route.get() === href;

        const badges = picture.badges().toArray();

        const album = picture.album();

        return m('.AlbumThumbnail', {
            className: active ? 'active' : '',
        }, [
            controls.length ? Dropdown.component({
                className: 'AlbumThumbnail-controls',
                menuClassName: 'Dropdown-menu--right',
                buttonClassName: 'Button Button--icon Button--flat',
                label: app.translator.trans('kilowhat-cimaise.forum.picture-controls.controls'),
                icon: 'fas fa-ellipsis-v',
            }, controls) : null,
            badges.length ? m('ul.AlbumThumbnail-badges badges', listItems(badges)) : null,
            m(Link, {
                href,
                onclick,
            }, m('img.AlbumThumbnail--picture', {
                src: picture.imageUrl(150),
            })),
            m('.AlbumThumbnail-meta', [
                m(Link, {
                    className: 'AlbumThumbnail-title',
                    href,
                    onclick,
                    title: picture.title(),
                }, picture.title()),
                vnode.attrs.showUser ? m('.AlbumThumbnail-user', [
                    app.translator.trans(translationPrefix + 'by-user'),
                    ' ',
                    avatar(picture.user() || null),
                    username(picture.user()),
                ]) : null,
                vnode.attrs.showAlbum && album ? m('.AlbumThumbnail-album', [
                    app.translator.trans(translationPrefix + 'in-album'),
                    ' ',
                    m(Link, {
                        href: cimaiseAlbum(album),
                    }, album.title()),
                ]) : null,
            ]),
        ]);
    }
}
